var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ddd",
    cx: 12,
    cy: 12,
    rx: 12,
    ry: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    strokeLinecap: "round",
    d: "M16.5103 9.01208L10.9523 14.5702L8.48959 12.1076C8.36425 11.9823 8.19426 11.9119 8.017 11.9119C7.83974 11.9119 7.66973 11.9823 7.54439 12.1076C7.41905 12.233 7.34863 12.403 7.34863 12.5802C7.34863 12.7575 7.41905 12.9275 7.54439 13.0529L10.4796 15.9881C10.605 16.1134 10.775 16.1838 10.9523 16.1838C11.1296 16.1838 11.2996 16.1134 11.425 15.9881L17.4556 9.95729C17.581 9.83193 17.6514 9.66192 17.6514 9.48465C17.6514 9.30738 17.5809 9.13737 17.4556 9.01202C17.3302 8.88668 17.1602 8.81627 16.9829 8.81628C16.8057 8.8163 16.6357 8.88673 16.5103 9.01208H16.5103Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/CompleteIcon.fa3ba1b89ba2e809016816f4fd71f5a8.svg";
export { ForwardRef as ReactComponent };